var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalonNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_175",
    "data-name": "Rect\\xE1ngulo 175",
    width: 40,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_574",
    "data-name": "Grupo 574",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_573",
    "data-name": "Grupo 573",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3317",
    "data-name": "Trazado 3317",
    d: "M40,20A20,20,0,1,1,20,0,20,20,0,0,1,40,20",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3318",
    "data-name": "Trazado 3318",
    d: "M27.683,22.068,22.068,3.014a18.965,18.965,0,0,0-11.05,3.53l.377,1.71L9.449,7.792a19.051,19.051,0,0,0,0,28.551l1.707-.368-.139,1.616a18.965,18.965,0,0,0,11.05,3.53Z",
    transform: "translate(-2.068 -2.068)",
    fill: "#b6db7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3319",
    "data-name": "Trazado 3319",
    d: "M74.114,35.683l2.2.66a19.051,19.051,0,0,0,0-28.551l-2.143.58.575-1.829A18.965,18.965,0,0,0,63.7,3.014V41.121a18.967,18.967,0,0,0,11.05-3.53Z",
    transform: "translate(-43.7 -2.068)",
    fill: "#9edb40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3320",
    "data-name": "Trazado 3320",
    d: "M77.316,29.779a18.055,18.055,0,0,1,7-14.276,19.127,19.127,0,0,0-1.568-1.248,20,20,0,0,0,0,31.049,19.127,19.127,0,0,0,1.568-1.248A18.055,18.055,0,0,1,77.316,29.779Z",
    transform: "translate(-51.7 -9.779)",
    fill: "#ebf3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3321",
    "data-name": "Trazado 3321",
    d: "M25.082,14.255A19.146,19.146,0,0,0,23.514,15.5a18.056,18.056,0,0,1,0,28.553A19.15,19.15,0,0,0,25.082,45.3a20.005,20.005,0,0,0,0-31.049Z",
    transform: "translate(-16.131 -9.779)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalonNav);
export default __webpack_public_path__ + "static/media/balonNav.31d9f627321c8d92d55e9f662ad1215c.svg";
export { ForwardRef as ReactComponent };